import React, { useState, useEffect, useContext, useRef } from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { Route, Link as RouterLink, withRouter } from 'react-router-dom'
import { getContentIndex, fetchContentIndex, getBusinessInfo } from 'alpha-js'
import { logEvent } from 'alpha-js'

import Page from './Page'
import TitleFilterSection from '../sections/TitleFilterSection'

const styles = theme => ({
  root: {
//    maxWidth: 480,
//    display: 'flex',
    width: '100%',
    minHeight: '100vh'
  },
  content: {
  },
  divider: {
    width: '100%',
    height: theme.spacing.unit,
//    backgroundColor: theme.palette.common.white,
    backgroundColor: '#eee'
  }
})

const BlogPage = ({ classes, history, openLink, business, blogList, categoryKey, categoryList, fetchBlogList, pageKey, fetchCategoryList }) => {

  const [initialized, setInitialized] = useState(false);
  
  const topElement = useRef()

  const lastFetched = blogList.lastFetched
  
  useEffect(() => {
    fetchBlogList()    
    fetchCategoryList()
    
    // if (lastFetched)
    //   logEvent('view', { type: 'content', uid: data.uid })
  
  }, [pageKey, categoryKey, lastFetched])
  
  const renderSections = (props) => {
    const { createSection, createContentBlock, divider, pageData } = props

    let sections = null
    
    let title = "All Posts"
    if (lastFetched && categoryKey)
      title = "All Posts in " + categoryKey.charAt(0).toUpperCase() + categoryKey.replace("-", " ").slice(1)    
      
    let filterItems = [
      { title: "All Posts", key: "all" },
      ...(categoryList.lastFetched
        ? categoryList.data.records.map(cat => (
            { title: cat.title, key: cat.key }
          ))
        : []
      )
    ]
    
    let selectedIndex = filterItems.findIndex(item =>
      (item.key == categoryKey) || (item.key == "all" && !categoryKey))
      
    const titleSection = {
      component: TitleFilterSection,
      title: "#### " + title,
      section_height: 30,
      color: { value: 'white' },
      selected_index: selectedIndex,
      items: filterItems,
      onClick: (item) => {
        if (item.key == "all")
          openLink("/blog")
        else
          openLink("/blog/" + item.key)
      }
    }

    const postItems = lastFetched ? blogList.data.records : []
    const postSection = {
      section_height: 20,
      component: 'ListSection',
      variant: 'Grid',
      text_alignment: { value: 'center' },
      item_size: { value: 'medium' },
      item_component_type: 'BlogItem',
      items: postItems
    }
    
    const sectionsData = [
      titleSection,
      postSection,
      // other defined sections
      ...(pageData.sections ? pageData.sections : [])
    ]
        
    sections = sectionsData.map((sectionData, index) => 
        createSection(sectionData, index)
      )
      // No Divider
      //.reduce((prev, next) => [prev, divider, next])

    return sections
  }
  
  const renderHelmet = ({ pageData }) => {
    let title = "All Posts"
    if (lastFetched && categoryKey)
      title = "All Posts in " + categoryKey.charAt(0).toUpperCase() + categoryKey.replace("-", " ").slice(1)

    return (    
      <title>{ title } - { process.env.REACT_APP_TITLE_SUFFIX }</title>
    )
  }

  return (
    <Page 
      pageKey='blog'
      renderSections={ renderSections }
      renderHelmet={ renderHelmet }
      />
    )
}

function categoryKeyFromProps(props) {
  let key = null
  if (props.match && props.match.params.categoryKey !== undefined)
    key = props.match.params.categoryKey
  return key
}

const mapStateToProps = (state, ownProps) => {
  let categoryKey = categoryKeyFromProps(ownProps)
  let indexKey = categoryKey ? categoryKey : 'default'

  return { 
    user: state.user,
    business: getBusinessInfo(state, '0').data,
    blogList: getContentIndex(state, 'blog', indexKey),
    categoryKey: categoryKey,
    categoryList: getContentIndex(state, 'blog-category', 'default'),
    pageKey: 'blog',
    }
} 

const mapDispatchToProps = (dispatch, ownProps) => {
  let categoryKey = categoryKeyFromProps(ownProps)
  let indexKey = categoryKey ? categoryKey : 'default'

  return {
    login: () => { dispatch(login()) },
    fetchBlogList: (refresh=false) => {
      let params = categoryKey ? { category_f: categoryKey } : null
      dispatch(fetchContentIndex('blog', indexKey, params, refresh))
    },
    fetchCategoryList: (refresh=false) => {
      dispatch(fetchContentIndex('blog-category', 'default', null, refresh))
    },
    logEvent: (eventName, data) => {
      dispatch(logEvent(eventName, data))
    },
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(BlogPage)
  )
)